<template>
    <div>
        <el-button type="primary" size="mini" plain @click="getData">
            <span class="el-icon-edit-outline">编辑图片</span>
        </el-button>
        <el-dialog
            title="楼盘相册"
            :visible.sync="showdialog"
            width="1200px"
            v-dialogDrag
            append-to-body>
            <div class="base-warp">
                <el-row class="head">
                    <el-col :span="12" :offset="0">
                        <span class="title">编辑相册</span>
                    </el-col>
                    <el-col :span="12" :offset="0">
                        <el-form label-width="200px" :inline="true" size="mini">
                            <el-form-item label="添加自定义分组">
                                <el-input class="input" v-model="custom" placeholder="填写自定义分组名称，点击添加" clearable></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="mini" icon="el-icon-plus" circle  @click="addGroup"></el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-collapse v-model="activeNames" :accordion="false">
                    <el-collapse-item v-for="(item, index) in types"
                        :key="index"
                        :name="index">

                        <template slot="title">
                            <div class="colla-head">
                                <span class="text">{{item}}</span>
                                <div class="head-btn">
                                    <el-button type="danger" size="mini" icon="el-icon-delete" circle @click.stop="delGroup(item, index)"></el-button>
                                </div>
                            </div>
                        </template>

                        <div class="file-warp">
                            <div class="img-warp" v-if="item=='缩略图'">
                                <div class="img-box">
                                    <el-button v-if="album[item]" class="del-btn" type="danger" size="mini" icon="el-icon-delete" circle @click.stop="delimg(item, '')"></el-button>
                                    <el-image class="img" :src="album[item]" fit="fill" :lazy="true"></el-image>
                                </div>
                            </div>
                            <div class="img-warp" v-else>
                                <div class="img-box" v-for="(img, ind) in album[item]" :key="ind">
                                    <el-button class="del-btn" type="danger" size="mini" icon="el-icon-delete" circle @click.stop="delimg(item, ind)"></el-button>
                                    <el-image class="img" :src="img.path" fit="fill" :lazy="true"></el-image>
                                </div>
                            </div>
                        </div>
                        <div class="upl-warp">
                            <el-upload
                                class="upload-demo"
                                drag
                                action="/api/Upload/uploadFile/"
                                :on-success="(response)=>{handleUploadSuccess(item,response)}"
                                :before-upload="beforeUpload"
                                :data="{type: item}"
                                multiple>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>
                            </el-upload>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div class="btn-box">
                <el-button type="primary" size="mini" @click="confirm">保存</el-button>
                <el-button type="default" size="mini" @click="confirm">取消</el-button>
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
    export default {
        name: 'ProjectAlbum2',
        data() {
            return {
                types: ['缩略图', '效果图', '实景图', '活动现场', '样板间', '装修案例'],
                showdialog: false,
                activeNames: [0],
                thumbnail: '',
                custom: '',
                filesList: [],
                album: {},
            }
        },
        mounted (options) {
          console.log(options,'optionsoptions');
            if (this.types){
                for (var typ of this.types){
                    if (typ == '缩略图'){
                        this.album[typ] = '';
                    } else {
                        this.album[typ] = [];
                    }
                }
            }
        },
        props: {
            id: {
                type: String,
            },
        },
        methods: {
            delimg(item, ind) {
                if (!ind&&item=='缩略图'){
                    this.album[item] = '';
                } else {
                    this.album[item].splice(ind, 1);
                }
                this.$forceUpdate()
            },
            delGroup(item, index) {
                if (item == '缩略图'){
                    this.$confirm('这个分类不允许删除')
                    return;
                }
                var ind = this.types.indexOf(item);
                if (this.album[item].length>0){
                    this.$confirm('分类中已经上传了图片，是否确定删除').then(
                        confirm=>{
                            this.types.splice(ind, 1);
                            delete this.album[item];
                        },
                        cancel=>{}
                    )
                    return;
                }
                this.types.splice(ind, 1);
                delete this.album[item];
            },
            addGroup() {
                var custom = this.custom;
                if (!custom) {
                    this.$confirm('请先填写分组的名称')
                    return;
                }
                if (this.types.indexOf(custom)>-1){
                    this.$confirm('分组已存在，不用重复添加')
                    return;
                }
                this.types.push(custom);
                this.album[custom] = [];
                this.custom = '';
            },
            getData() {
                this.showdialog = true;
                var params = {
                    id: this.id,
                }
                this.$api.getProjectAlbumVsId(params).then(
                data=>{
                    let {types, album} = data;
                    if (types.length>1) {
                        this.types = types;
                        for (var t of types){
                            if (t=='缩略图'){
                                this.album[t] = '';
                            } else {
                                this.album[t] = [];
                            }
                        }
                    }
                    for(var al of album){
                        if (al.name=='缩略图'){
                            this.album[al.name] = al.path;
                        } else {
                            this.album[al.name].push(al);
                        }
                    }
                    this.$forceUpdate()
                }
            )
            },
            confirm() {
                var album = this.album;
                var types = this.types;
                var alb = [];
                for (var ty of types){
                    if (ty!='缩略图'){
                        alb = alb.concat(album[ty])
                    }
                }
                var params = {
                    id: this.id,
                    album: JSON.stringify(alb),
                    thumbnail: album['缩略图']
                }
                this.$api.editProjectAlbum(params).then(
                data=>{
                    this.$message.success(data);
                    this.showdialog = false;
                }
            )
            },
            handleUploadSuccess(item,response) {
                let {data, errCode, msg} = response;
                if (data){
                    this.$message.success(msg);
                    if (item=='缩略图'){
                        this.album[item] = data;
                    } else {
                        var obj = {
                            name: item,
                            path: data,
                        }
                        this.album[item].push(obj);
                    }
                    this.$forceUpdate()
                } else {
                    this.$message.error(msg);
                }
            },
            beforeUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isPNG  = file.type === 'image/png';
                // const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isJPG&&!isPNG) {
                    this.$message.error('只能上传图片，不能上传其他文件!');
                }
                // if (!isLt2M) {
                //     this.$message.error('上传的图片大小不能超过 1MB!');
                // }

                return isJPG||isPNG;
            },
        },
    }
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
.head{
    .title{
        line-height: 28px;
    }
    .input{
        width: 280px;
    }
}
.colla-head{
    width: 100%;
    .head-btn{
        float: right;
        margin-right: 40px;
    }
}
.file-warp{
    margin-bottom: 4px;
    .img-warp{
        width: 100%;
        overflow: hidden;
        .img-box{
            width: 233px;
            height: 160px;
            border: 1px dashed #eee;
            float: left;
            box-sizing: border-box;
            margin-right: 10px;
            margin-bottom: 10px;
            position: relative;
            .del-btn{
                position: absolute;
                top: 0;
                right: 0;
                z-index: 10;
            }
            .img{
                width: 230px;
                height: 158px;
                vertical-align: middle;
            }
        }
    }
}
.upl-warp{

}
</style>